import { createSlice } from "@reduxjs/toolkit";
import { getLoggedInUserDetails } from "./thunk";

const getLoggedInUserDetailsSlice = createSlice({
    name: "getLoggedInUserDetails",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getLoggedInUserDetails.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getLoggedInUserDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getLoggedInUserDetails.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

    }
});

export default getLoggedInUserDetailsSlice.reducer;